import React from 'react';
import styled from 'styled-components';
import homeImage from '../../assets/homeImage.png';

export default function Hero() {
 return (
  <Container>
   <Wrapper>
    <div>
     <div className='header'>
      <Heading>
       New to <span>EPR</span>?
      </Heading>
      <Linebreak>
       <div className='part1'></div>
       <div className='part2'></div>
       <div className='part3'></div>
      </Linebreak>
     </div>
     <Content>
      <h3>What is Extended Producer Responsibility (EPR)?</h3>
      <p>
       Extended Producer Responsibility (EPR) is a policy approach under which
       producers are given a significant responsibility – financial and/or
       physical – for the treatment or disposal of post-consumer products.
      </p>{' '}
      <p>
       EPR is the responsibility of a producer for the environmentally sound
       management of the product until the end of its life.‍
      </p>{' '}
      <p>
       It may include implementing a take-back system by setting up collection
       centres and having agreed arrangements with the concerned parties either
       individually or through a recognized Producer Responsibility Organization
       (PRO).
      </p>
     </Content>
    </div>
    <div>
     <Image src={homeImage} alt='hand holding a small plant' />
    </div>
   </Wrapper>
  </Container>
 );
}

const Container = styled.div`
 width: 100%;
 height: auto;
 background: #000;
`;

const Wrapper = styled.div`
 display: flex;
 align-items: center;
 width: 75%;
 margin: 8rem auto 15rem auto;
 div {
  width: 100%;
  height: 100%;
 }
 .header {
  width: fit-content;
 }
 @media screen and (max-width: 600px) {
  flex-direction: column;
 }
`;

const Heading = styled.h1`
 font-size: 3.2rem;
 font-weight: 700;
 line-height: 7rem;
 /* font-family: 'Segoe UI'; */
 color: #fff;
 span {
  color: #90d62b;
 }
`;

const Linebreak = styled.div`
 width: 50%;
 display: flex;
 gap: 0.5rem;
 margin-top: -1rem;
 div {
  background-color: #84d908;
  border-radius: 1rem;
  height: 0.5vh;
 }
 .part1 {
  width: 40%;
 }
 .part2 {
  width: 30%;
 }
 .part3 {
  width: 10%;
 }
`;

const Content = styled.div`
 margin-top: 2rem;
 /* font-family: 'Segoe UI'; */
 color: #dfdfdf;
 text-align: justify;
 h3 {
  font-size: 2.2rem;
  font-weight: 400;
  line-height: 4.8rem;
  text-transform: capitalize;
 }
 p {
  font-size: 1.5rem;
  font-weight: 400;
  line-height: 2rem;
 }
`;

const Image = styled.img`
 width: 70%;
 height: auto;
 object-fit: cover;
`;
